<template>
  <div>
    <div class="setting-section">
      <p class="setting-section__h">Основные настройки</p>
      
      <div class="setting-row">
        <label>Цвет</label>
        <div class="setting-column">
          <ColorPicker
            :model-value="landingSettings.bg_color"
            @update:model-value="onColorChange"
          />
        </div>
      </div>

      <!--<div class="setting-row">
        <label>Шрифт</label>
        <div class="setting-column">
          <FontSelect
            :activeFont="selectedFontLocal.family"
            :options="{ name: 'main' }"
            @change="onFontChange"
          />
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import FontSelect from "@/components/UI/Select/FontSelect.vue";
import ColorPicker from "@/components/UI/ColorPicker/index.vue";

export default {
  name: "BaseSettings",
  components: { FontSelect, ColorPicker },
  props: {
    selectedColor: { type: String, required: true },
    selectedFontLocal: { type: Object, required: true },
  },
  computed: {
    landingSettings() {
      return this.$store.getters['landing/landingSettings'] || { fonts: [], bg_color: 'transparent' }
    },
  },
  methods: {
    copyId(text) { 
      if (!text) 
        return Promise.resolve(); 
        if (navigator.clipboard && window.isSecureContext) 
          return navigator.clipboard.writeText(text); 
          const ta = document.createElement('textarea'); 
          ta.value = text; 
          ta.style.position = 'fixed'; 
          ta.style.left = '-9999px'; 
          document.body.appendChild(ta); 
          ta.focus(); 
          ta.select(); 
          try { 
            document.execCommand('copy'); 
          } 
          catch(e) {} 
          document.body.removeChild(ta); return Promise.resolve(); 
    },
    onColorChange(color) {
      this.$emit("update:selectedColor", color);
      this.$store.dispatch("landing/UPDATE_LANDING_SETTINGS", {
        ...this.landingSettings,
        bg_color: color,
      });
    },
    onFontChange(font) {
      this.$emit("update:selectedFontLocal", font);
    },
  },
};
</script>

<style scoped>
.setting-section { padding-bottom: 0.5rem; margin-top: 0.5rem; border-bottom: 0.1rem solid var(--grey-0); display: flex; flex-direction: column; gap: 0.5rem; }
.setting-row { 
  display: flex; 
  align-items: 
  center; 
  gap: 0.5rem; 
}
.setting-column { display: flex; flex-direction: column; gap: 0.5rem; width: 100%; }
.setting-section__h {
  text-align: start;
  font-weight: bold;
}
</style>
